import { Typography, Avatar } from "antd";
import { UserOutlined, AntDesignOutlined } from "@ant-design/icons";
import { useNavigate , useOutletContext } from "react-router-dom";
import { UserInfo } from "../../interface";

import logo from "../../assets/EmptyState.png";
import { useEffect } from "react";

const { Title, Text } = Typography;

const Dashboard: React.FC = () => {
  const data = useOutletContext() as UserInfo;
  console.log("Dashboard");
  const navigate = useNavigate();

  useEffect(() => {
    if (data.role === "Owner") {
      navigate('/organisations')
    }
  }, []);
  
  return (
    <>
      <div
        style={{
          background: "white",
          borderRadius: 4,
          boxShadow: "0 0 8px 0 #cbcbcb",
          padding: 20,
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ height: 60, width: 60, marginRight: 10 }}>
            <Avatar
              size={60}
              icon={<UserOutlined style={{ fontSize: 40 }} />}
              style={{ backgroundColor: "#40a9ff" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: 52,
            }}
          >
            <Title level={5} style={{ marginBottom: 0 }}>
              Welcome, {data.alias}
            </Title>
            <div>
              <Avatar
                size={20}
                icon={<AntDesignOutlined style={{ fontSize: 12 }} />}
                style={{ marginRight: 6, backgroundColor: "#40a9ff" }}
              />
              <Text type="secondary" style={{ fontSize: 14 }}>
                {data.role === "Owner"
                  ? data.organizations?.map((item) => item.name).join(" | ")
                  : data.organization?.name}
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div style={{ color: "#c8c8c8", textAlign: "center", marginTop: 100 }}>
        <div>
          <img
            src={logo}
            style={{ height: 280, marginBottom: 30 }}
            alt="vtkd_background"
          />
        </div>
        <Title level={2} style={{ color: "inherit", marginBottom: 0 }}>
          Coming Soon
        </Title>
        <Text style={{ color: "inherit" }}>
          We are working hard to get new features up and running
        </Text>
      </div>
    </>
  );
};

export default Dashboard;
